// HistoryItem.js
import React from "react";
import { 
  OrderedListOutlined, 
  ClockCircleOutlined, 
  CalendarOutlined,
  CalculatorOutlined,
  BulbOutlined,
  FireOutlined,
  EnvironmentOutlined,
  BookOutlined,
  HistoryOutlined,
  GlobalOutlined,
  LaptopOutlined,
  ExperimentOutlined,
  FileTextOutlined
} from '@ant-design/icons';

const HistoryItem = ({ item, index, onClick }) => {
  const getIconComponent = (iconName, color) => {
    const iconStyle = { color, fontSize: '24px' };
    
    switch(iconName) {
      case 'calculator':
        return <CalculatorOutlined style={iconStyle} />;
      case 'bulb':
        return <BulbOutlined style={iconStyle} />;
      case 'fire':
        return <FireOutlined style={iconStyle} />;
      case 'leaf':
        return <EnvironmentOutlined style={iconStyle} />;
      case 'book':
        return <BookOutlined style={iconStyle} />;
      case 'history':
        return <HistoryOutlined style={iconStyle} />;
      case 'globe':
        return <GlobalOutlined style={iconStyle} />;
      case 'laptop':
        return <LaptopOutlined style={iconStyle} />;
      case 'experiment':
        return <ExperimentOutlined style={iconStyle} />;
      case 'file-text':
      default:
        return <FileTextOutlined style={iconStyle} />;
    }
  };

  const formatDate = (dateString) => {
    try {
      const date = new Date(dateString);
      return date.toLocaleDateString('en-US', {
        month: 'short',
        day: 'numeric',
        year: 'numeric'
      });
    } catch (error) {
      return dateString;
    }
  };

  const getTimeAgo = (dateString) => {
    try {
      const date = new Date(dateString);
      const now = new Date();
      const diffTime = Math.abs(now - date);
      const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24));
      
      if (diffDays === 0) return 'Today';
      if (diffDays === 1) return 'Yesterday';
      if (diffDays < 7) return `${diffDays} days ago`;
      if (diffDays < 30) return `${Math.floor(diffDays / 7)} weeks ago`;
      return `${Math.floor(diffDays / 30)} months ago`;
    } catch (error) {
      return 'Recently';
    }
  };

const percentage = (item) => {
  if (!item.totalQuestions || item.totalQuestions === 0) return 0;
  return Math.round((item.score / item.totalQuestions) * 100);
};
 
  return (
    <div 
      className={`history-item ${index === 0 ? 'first-item' : ''}`}
      onClick={() => onClick(item)}
      role="button"
      tabIndex={0}
      onKeyPress={(e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          onClick(item);
        }
      }}
    >
      <div className="item-header">
        <div className="icon-container" style={{ backgroundColor: `${item.color}20` }}>
          {getIconComponent(item.icon, item.color)}
        </div>
        <div className="title-container">
          <h3 className="item-title" title={item.title}>{item.title}</h3>
          <div className="item-meta">
            <span className="item-type">{item.type}</span>
            <span className="item-date">• {formatDate(item.date)}</span>
            <span className="examination-item-type"> • {item.classLevel}</span>
          </div>
        </div>
        <div className="score-container">
          {item.status === 'completed' ? (
            <>
              <div className="score-text">{percentage(item)}%</div>
              <div className="score-label">Score</div>
            </>
          ) : item.status === 'in-progress' ? (
            <div className="in-progress-badge">
              In Progress
            </div>
          ) : (
            <div className="pending-badge">
              Pending
            </div>
          )}
        </div>
      </div>
      
      <div className="item-details">
        <div className="detail-item">
          <OrderedListOutlined className="detail-icon" />
          <span className="detail-text">{item.totalQuestions} questions</span>
        </div>
        <div className="detail-item">
          <ClockCircleOutlined className="detail-icon" />
          <span className="detail-text">{item.timeSpent}</span>
        </div>
        <div className="detail-item">
          <CalendarOutlined className="detail-icon" />
          <span className="detail-text">{getTimeAgo(item.date)}</span>
        </div>
      </div>
    </div>
  );
};

export default HistoryItem;